import { computed } from "vue";
import { createSingularAsyncApi } from "../../partials/async";
import { createToast } from "@/modules/toast-message"

export default function createMembershipTypeData(){
    const api = createSingularAsyncApi(
        'bt_get_membership_type_by_id',
        'GET',
        {
            responseKey: 'membership_type',
            onError    : (data) => {
                if(data.code === 404){
                    createToast("This membership type couldn't be found, please select another", "error")
                } else {
                    createToast("Couldn't load membership type, please try again", "error")
                }
            }
        }
    )

    /**
     * If the membership should be for an individual
     */
    const is_individual_membership = computed(
        () => api.details.value?.entity_type?.value === 'individual'
    )

    /**
     * If the membership should be for an organisation
     */
    const is_organisation_membership = computed(
        () => api.details.value?.entity_type?.value === 'organisation'
    )

    return {
        ...api,

        is_individual_membership   : is_individual_membership,
        is_organisation_membership : is_organisation_membership
    }
}